import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import { FinancialInstrumentsFields } from './FinancialInstrumentsFields';
import { InformationAboutOperationsFields } from './InformationAboutOperationsFields';
import { Section } from './Section';

export interface FormContentProps {}

export const FormContent = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={32}>
      <Section
        title={t(
          'client.legal.targetedFinancialInstruments.financialInstruments.title'
        )}
      >
        <FinancialInstrumentsFields />
      </Section>

      <Section
        title={t(
          'client.legal.targetedFinancialInstruments.informationAboutOperations.title'
        )}
      >
        <InformationAboutOperationsFields />
      </Section>
    </Stack>
  );
};
